export default string => string.match(/[A-Za-z0-9_\-:.@()+,=;$!%*']/g) && (string.match(/[A-Za-z0-9_\-:.@()+,=;$!%*']/g).length == string.length);



// WEBPACK FOOTER //
// ./src/utils/is-valid-username.js